import {
  MomentHourAndMinuteTime,
  getHrMinFormat,
  getValidData,
} from "../../../Shared/Methods";
import { Tablenodatafound } from "../TableNoDataFount";

function ConsumptionTable({ Data, OBJHead }: { Data: any; OBJHead: string[] }) {
  return (
    <>
      <tr>
        {OBJHead?.map((ele: any, index: number) => {
          return <th key={index}>{ele}</th>;
        })}
      </tr>

      {Data?.length > 0 ? (
        Data.map((ele: any, ind: number) => {
          return (
            <>
              <tr>
                <td rowSpan={ele?.data?.length + 1} key={ind}>
                  {ind + 1}
                </td>
                <td
                  rowSpan={ele?.data?.length + 1}
                  style={{ minWidth: "100px" }}
                >
                  {getValidData(ele?.date)}
                </td>
              </tr>

              {ele?.data?.map((ele: any, index: number) => {
                return (
                  <>
                    <tr>
                      <td key={index}>
                        {getValidData(
                          ele?.startDatetime
                            ? MomentHourAndMinuteTime(ele?.startDatetime)
                            : ""
                        )}
                      </td>
                      <td>
                        {getValidData(
                          ele?.endDatetime
                            ? MomentHourAndMinuteTime(ele?.endDatetime)
                            : ""
                        )}
                      </td>
                      <td style={{ width: "100px" }}>
                        {getValidData(ele?.startReading)}
                      </td>
                      <td style={{ width: "100px" }}>
                        {getValidData(ele?.todayConsumption)}
                      </td>
                      <td>
                        {getValidData(
                          ele?.pin_1_duration
                            ? getHrMinFormat(ele?.pin_1_duration)
                            : ""
                        )}
                      </td>
                      <td>
                        {getValidData(
                          ele?.pin_2_duration
                            ? getHrMinFormat(ele?.pin_2_duration)
                            : ""
                        )}
                      </td>
                      <td>
                        {getValidData(
                          ele?.pin_3_duration
                            ? getHrMinFormat(ele?.pin_3_duration)
                            : ""
                        )}
                      </td>
                    </tr>
                  </>
                );
              })}
            </>
          );
        })
      ) : (
        <Tablenodatafound />
      )}
    </>
  );
}

export default ConsumptionTable;
